import { callApi } from '../common/services/baseServices';
import moment from "moment";
import {detectIconById, getCookie} from './../common/enum/index';
import { host } from '../environment';
import axios from '../axios';
import {getCategoryName} from "./delivery";

const ACTIONS = {
    GET_MY_TOPIC_SUCCESS: 'GET_MY_TOPIC_SUCCESS',
    GET_MY_TOPIC_ERROR: 'GET_MY_TOPIC_ERROR',
    GET_LIST_MY_TOPIC_SUCCESS: 'GET_LIST_MY_TOPIC_SUCCESS',
    GET_LIST_MY_TOPIC_ERROR: 'GET_LIST_MY_TOPIC_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getMyTopic = () => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    // category (string)
    // id (number)
    let url = `${host.serverTest}api/topics/categories/${'1'}/id/${2}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                // console.log(data);

                dispatch(updateStatus(ACTIONS.GET_MY_TOPIC_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_MY_TOPIC_ERROR, err));
            });
    };

};

const getWorkspace = (page) => {
    return async () => {
        const {data} = await axios.get('api/me');
        if(data.role) {
            return axios.get('api/admin/deliveries/workspaces', {
                params: {
                    page,
                    keyword: ''
                }
            }).then(({data}) => data);
        }
        return await axios.get('api/deliveries/workspaces', {
            params: {
                page,
                keyword: ''
            }
        }).then(({data}) => data);
    }
};
const getListMyTopic = (params) => {
    return async () => {
        const {keyword, order, page, sort} = params;
        const {data} = await axios.get('api/topics', {
            params: {
                keyword: keyword,
                order: order,
                page: page,
                sort: sort,
            }
        });

        return {
            ...data,
            data: data.data.map(topic => {
                let name = '';
                let categoryName = getCategoryName(topic.category_name);

                if(topic.player) {
                    name = topic.player.player_name;
                }

                if(topic.team) {
                    name = topic.team.team_name_s;
                }

                if(topic.game) {
                    name = moment(topic.game.game_date).format('M/D') + " " + topic.game.home_team.team_name_s + " - " + topic.game.away_team.team_name_s;
                }
                return {
                    ...topic,
                    name,
                    categoryName
                }
            })
        };
    }
};

const getTeams = () => {
    return async () => {
        try {
            const {data} = await axios.get('api/masters/teams');
            const teams = [...data.central_league, ...data.pacific_league];
            return teams.map(item => {
                item.icon = detectIconById(item.id);
                return item;
            });
        } catch (error) {
            console.log(error);
        }
    };
};

const getGames = (params) => {
    return async () => {
        try {
            const {data} = await axios.get('api/masters/games', {params});
            return data;
        } catch (error) {
            console.log(error);
        }
    };
};


const saveTopicToGame = (gameId, params) => {
    return async () => {
        try {
            const {data} = await axios.post(`/api/games/${gameId}/topics/players`, params);
            return data;
        } catch (error) {
            console.log(error);
        }
    };
};

const getTopicsInPlayer = (playerId) => {
    return async () => {
        const {data} = await axios.get(`api/topics/categories/player/id/${playerId}`);
        return data;
    }
}

const deleteTopic = (topicId) => {
    return async () => {
        try {
            const {data} = await axios.delete(`api/topics/${topicId}`);
            return data;
        } catch (error) {
            console.log(error);
        }
    };
};

const updateTopic = (params) => {
    return async () => {
        try {
            const {data} = await axios.put(`api/topics/${params.topicId}`, {
                title: params.title,
                topic_status_id: params.topicStatusId || 1,
            });
            return data;
        } catch (error) {
            console.log(error);
        }
    };
};

const createTopic = (params) => {
    return async () => {
        const {workspace_id, game_id, team_id, player_id} = params;
        return axios.post('api/topics', {
            workspace_id,
            game_id,
            team_id,
            player_id,
        });
    }
};

const copyTopic = (params) => {
    return async () => {
        const {topicId, workspace_id} = params;
        return axios.post(`api/topics/${topicId}/copy`, {
            workspace_id: workspace_id
        });
    };
};

const convertMyTopic = (list) => {
    console.log(list);

    if (list.length) {
        const arr = list.data.map((value, index) => {
            return {
                item: [
                    { text: value.title },
                    { text: value.workspace.title },
                    { text: value.category_name },
                    {
                        text: value.category_name === 'game'
                            ?    `${value.game.away_team.team_name} - ${value.game.home_team.team_name}`
                            :   value.category_name === 'team'
                            ?   value.team.team_name
                            :   value.player.player_name
                    },
                    { text: value.created_at },
                    { text: value.updated_at },
                    {
                        action: ['ワークスペースにコピー', '複製', '編集', '削除']
                    }
                ]
            }
        });
        return arr;
    }
}


export {
    ACTIONS, getMyTopic,
    convertMyTopic, getListMyTopic,
    createTopic, getTeams,
    getGames, deleteTopic,
    updateTopic, copyTopic,
    getWorkspace, getTopicsInPlayer,
    saveTopicToGame,
};
